import { AuthenticationService } from 'src/api/authentication_service';
import { getApp } from 'src/config/environment';
import { USER_INFO_STORAGE_KEY } from 'src/constants/key_constants';
import { getWorkflowTypeForOrganization } from 'src/distribution_platforms/features/workflows';
import { UserInfo } from 'src/hooks/use_auth';
import { WorkflowType } from 'src/types/workflows';

/**
 * Base class for the implementation of a fake repository.
 * Contains common functionality for fake repositories, such as accessing
 * the user info from local storage.
 */
export abstract class FakeRepository {
  /**
   * Gets the user info from local storage.
   * @returns The user info.
   */
  getUserInfo(): UserInfo {
    const userInfoJson = localStorage.getItem(USER_INFO_STORAGE_KEY);

    if (userInfoJson) {
      return JSON.parse(userInfoJson);
    }

    throw new Error('User info not found');
  }

  /**
   * Returns the workflow type for the currently authenticated organization.
   */
  getWorkflowType(): WorkflowType {
    const org = AuthenticationService.getInstance().getEffectiveOrganization();
    return getWorkflowTypeForOrganization(org, getApp());
  }
}
